import { IconCalendarStats } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { WorkerAttendanceCaptureBlock as RenderWorkerAttendanceCaptureBlock } from '../../templateRenderer/CaptureBlocks/WorkerAttendanceCaptureBlock'
import { WorkerAttendanceDisplayBlock as RenderWorkerAttendanceDisplayBlock } from '../../templateRenderer/DisplayBlocks/WorkerAttendanceDisplayBlock'
import {
  AttendanceValue,
  SubcontractorAttendance,
  WorkerAttendanceCaptureBlock,
  WorkerAttendanceDisplayBlock,
} from '../../types/blueprint'
import { HourConfigInput } from '../SideEditors/CustomInputs/HourConfigInput/HourConfigInput'

import { BaseBlockConfig, Field, TypeOption } from './_BaseBlockConfig'

import { TemplateType } from 'types/api.graphql'

class Config extends BaseBlockConfig<WorkerAttendanceCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'workerAttendance' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Worker attendance',
    icon: IconCalendarStats,
    exclusiveTemplateTypes: [TemplateType.SiteDiary],
    helpText:
      'Automatically pull in sign worker on/off times, then manually make adjustments',
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'hourConfig',
      label: 'Configure custom hours',
      field: { component: HourConfigInput },
    },
  ]

  /**
   * Strip all non-manually created attendances and visitors, they will be dynamically fetched each time
   */
  public override mapFormValueToBlock(
    block: WorkerAttendanceCaptureBlock,
    value: AttendanceValue
  ): WorkerAttendanceCaptureBlock {
    return {
      ...block,
      value: {
        visitors: [],
        overrides: value?.overrides,
        subcontractorAttendances: value?.subcontractorAttendances
          ?.map<SubcontractorAttendance>((s) => ({
            subcontractorId: s.subcontractorId,
            manuallyCreated: s.manuallyCreated,
            comments: s.comments,
            workerAttendance: s.workerAttendance.filter(
              (w) => !!w.manuallyCreated
            ),
          }))
          .filter(
            (s) =>
              !!s.manuallyCreated ||
              s.workerAttendance.some((w) => !!w.manuallyCreated) ||
              !!s.comments // if they have comments, we needa save it
          ),
      },
    }
  }

  public override renderBlock(
    block: WorkerAttendanceCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderWorkerAttendanceCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: WorkerAttendanceDisplayBlock
  ): React.ReactNode {
    return <RenderWorkerAttendanceDisplayBlock block={block} />
  }
}

export const WorkerAttendanceCaptureBlockConfig = new Config()
